import { useGetUserPreferences } from '@utils/api/organizations/user-preferences/use-get-user-preferences.tsx';
import { DISABLE_NUMPAD_SHORTCUTS_KEY } from '@utils/constants/app-constants.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';

/**
 * Reads the "disable numpad shortcuts" user preference (#4029).
 *
 * Defaults to ``false`` so numpad shortcuts stay on for every user until they
 * explicitly opt out — the requirement is to preserve existing workflows.
 *
 * The same hook is used by all four editor hotkey providers (caption, shared
 * caption, transcript, shared transcript) so the toggle in Profile → Keyboard
 * applies uniformly. Anonymous share-link visitors skip the request and keep
 * the default (numpad enabled). Refetching on focus picks up a toggle made in
 * another tab while an editor is open.
 */
export const useNumpadShortcutsDisabled = (): boolean => {
  const { data: preferences } = useGetUserPreferences({
    enabled: !!TokenExtension.get()?.string,
    refetchOnWindowFocus: 'always'
  });
  return (
    preferences?.result.find(item => item.key === DISABLE_NUMPAD_SHORTCUTS_KEY)
      ?.value === 'true'
  );
};
